import React from 'react';
import image from '../assets/img/notice1.jpg';

export default function Modal({ isOpen, title, date, count, img, data, onClose }) {
  return (
    <div className="flex flex-col px-4 pb-52 pt-28 mt-72 h-full">
        <div className={`${isOpen ? 'flex' : 'hidden'} w-full h-full px-24 items-center justify-center`}>
            {/* <div className="fixed top-0 left-0 w-full h-full" onClick={onClose}></div> */}
            <div className="w-full bg-gray-100 rounded-2xl p-8">
                <div className="flex justify-between items-center">
                    <span className="text-xl font-semibold mb-4">{title}</span>
                    <button className="text-gray-500 text-2xl" onClick={onClose}>
                        &times;
                    </button>
                </div>
                <div className="flex flex-col w-full text-base">
                    <p className="mb-4">작성일 : {date}</p>
                    {img && <img src={image} alt="Notice" className="h-40 object-scale-down" />}
                    <p>{data}</p>
                </div>
            </div>
        </div>
    </div>
  );
}
